<template>
  <form class="mt-2" id="form-modal">
{{getSelctedAssignedUser}}

    <!-- description input -->
      <div class="form-group">
        <label>Select User</label>
       <select class="form-control py-0" name="template" v-model="selected">
            <option v-for="item in adminUsers" v-bind:key="item.id" :value="item.id">
               {{item.full_name}}
           </option>
       </select>
       </div>
    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary text-light btn-sm" data-dismiss="modal">
        Close
      </button>
      <button type="button" :disabled="isMiniLoading" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" class="btn btn-success text-light btn-sm ml-1" @click="save()">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Assign
      </button>
    </div>
  </form>
</template>

<script>
  import axios from "axios";
  import Multiselect from "vue-multiselect";
  import {hasPermission} from "../../utils/permissions";
  export default {
    components: {
      Multiselect
    },
    props: ["action", "formData", "pageNumber", "status"],
    data: function () {
      return {
       adminUsers: [],
       isMiniLoading: false,
       selected: "",
      };
    },
    created: function () {
      if(hasPermission('lead_assign_lead')){
        const permission = {
          headers: {
            'X-Permission': 'lead_assign_lead'
          }
        };
        axios.get('/admin/users/get-all-users?role_id=' + 2,permission)
            .then((response) => {
              let res = response.data;
              this.adminUsers = res.data;
            });
      }
    },
    computed: {
        getSelctedAssignedUser: function () {
         this.selected = this.formData.assign_to;
      },
    },
    methods: {
      save() {
        this.isMiniLoading = true;
        let page_no = this.formData.pageNumber;
        let lead_id = this.formData.lead_id;
        let assign_filter  = this.formData.assign_filter;
        let crm_id  = this.formData.crm_id;

        if(assign_filter == '' || assign_filter == 'all'){
          assign_filter = 'all';
          crm_id = 'all';
        }else{
          assign_filter = 'crm'
        }
        if (this.selected != null && this.selected != "") {
          if(hasPermission('lead_assign_lead')){
            const permission = {
              headers: {
                'X-Permission': 'lead_assign_lead'
              }
            };
            axios.post("/admin/users/assign-lead", {
              user_id:this.selected,
              role:2,
              lead_id:lead_id,
            },permission)
                .then(() => {
                  this.isMiniLoading = false;
                  this.$toast.success("Lead Assigned Successfully!");
                  window.$("#modal").modal("hide");
                  this.$store.dispatch("users/getAllDemoRequests", [page_no,"", this.formData.status, "","", "", "", "", "", this.formData.color ? this.formData.color : "", 'all', 'all', 'all',assign_filter,crm_id,0]);
                })
                .catch((error) => {
                  this.isMiniLoading = false;
                  this.$toast.error(error);
                });
          }
        } else {
          this.isMiniLoading = false;
          this.$toast.warning("Please Select User First");
        }
      },
    },
  };
</script>